import React, { useContext, useMemo } from "react";

import "./EUMRVVoyages.scss";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	EUMRV_VOYAGES_HEADERS,
	EuVoyagesDerogationIceClassColumns,
} from "../../../../../../constants/CustomTableHeaders";
import { ClaimsContext } from "../../../../../../services/ClaimsService";
import { FeatureType } from "../../../../../../constants/FeatureToggles";

const EuVoyagesDerogationIceClass = ({ data }) => {
		const mrvAccessorKeys = [
		"co2Mrv",
		"ch4Mrv",
		"n2oMrv",
		"co2EqMrv",
	];
	
	const dynamicColumns = useMemo(() => {
		
			return EuVoyagesDerogationIceClassColumns?.filter(
				col => !mrvAccessorKeys.includes(col.accessorKey)
			);

	}, [EuVoyagesDerogationIceClassColumns]);

	return (
		<div className="EUMRV-custom-table-container mt-3 eu_mrv_voyage">
			<CustomTable
				columnsData={dynamicColumns}
				renderTableData={data || []}
				customProps={{
					header: EUMRV_VOYAGES_HEADERS.ICE_CLASS,
					enableSort: false,
					tableName: "emissions-report",
					maxHeight: "30vh",
				}}
			/>
		</div>
	);
};

export default EuVoyagesDerogationIceClass;
